module.exports = __webpack_public_path__ + "img/classic_5.40e20826.jpg";